/** @format */

import { AfterViewInit, Directive, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[sharedUtilsDirectiveAppNoBackground]',
})
export class NoBackgroundDirective implements AfterViewInit {
  @Input() sharedUtilsDirectiveAppNoBackground: string;
  @Input() textColor: string;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngAfterViewInit() {
    this.setStyle();
  }

  /* istanbul ignore next */
  setStyle() {
    // if sharedUtilsDirectiveAppNoBackground is false, there should not be a background on the copy box
    if (
      !this.sharedUtilsDirectiveAppNoBackground ||
      this.sharedUtilsDirectiveAppNoBackground === 'false'
    ) {
      // Sets background to transparent
      this.renderer.addClass(this.el.nativeElement, 'transparent-background');
    }

    this.renderer.addClass(
      this.el.nativeElement,
      this.textColor === 'light' ? 'light-text' : 'dark-text',
    );
  }
}
